module.exports = __webpack_public_path__ + "79b7cacc5ad2193aa496390b59babd77.svg";